var scope_0 = require('/opt/build/repo/packages/matcha-bot-doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/054c0da705064c1b1fb20b9eb03af41b.js').default;

var scope_1 = require('/opt/build/repo/packages/matcha-bot-doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/12c780d06765c64dfd423f61c33d0aeb.js').default;

var scope_2 = require('/opt/build/repo/packages/matcha-bot-doc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2);